import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    // 品智企业驾驶舱
    path: '/',
    name: 'cockpit',
    component: () => import('../views/cockpit/index.vue')
  },
  {
    // 销售平台数字管理看板
    path: '/spDigitalSigns',
    name: 'spDigitalSigns',
    component: () => import('../views/spDigitalSigns/index.vue')
  },
  {
    // 采购数字管理看板
    path: '/purchaseDigitalSigns',
    name: 'purchaseDigitalSigns',
    component: () => import('../views/purchaseDigitalSigns/index.vue')
  },
  {
    // 生产管理看板
    path: '/productionDigitalSigns',
    name: 'productionDigitalSigns',
    component: () => import('../views/productionDigitalSigns/index.vue')
  },

]
const router = new VueRouter({
  mode: "hash",
  routes
})

export default router